import React, { Fragment, useState } from "react";
import { Label, Input } from "@revvsales/components";

import { UpgradeBadge, UpgradePopUp } from "../../../../commonComponents";

export default function PricingMethodOptionsUpgrade(props) {
  const { type, pricingMethodData, pricingMethodLabels } = props;
  const [showPopUp, togglePopUp] = useState(false);
  return (
    <Fragment>
      <div
        onClick={() => togglePopUp(true)}
        onKeyDown={() => togglePopUp(true)}
        role="button"
        tabIndex={0}>
        <Label
          className="pricing-individual-radio is-disabled"
          htmlFor={`${type.alias}-type`}
          key={type.alias}>
          <Input
            className="pricing-radio-button"
            id={`${type.alias}-type`}
            type="radio"
            value={type.label}
            checked={pricingMethodData.view === type.label}
            name={type.alias}
            readOnly
          />
          <div className="pricingmethodwrapper-title-wrapper-upgrade">
            <span className="pricingmethodwrapper-title">
              {pricingMethodLabels[type.label]}
            </span>
            <span className="pricingmethodwrapper-description" />
            <span className="upgrade-icon">
              <UpgradeBadge />
            </span>
          </div>
        </Label>
      </div>
      {showPopUp && (
        <UpgradePopUp
          featureName={props.featureName}
          onClose={() => togglePopUp(false)}
        />
      )}
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/Pricebook/PricingMethodWrapper/PricingMethodOptions/PricingMethodOptionsUpgrade.js